/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { motion } from 'framer-motion';

export function ErrorPop(props) {
  const duration = props.duration || 0.2;
  return (
    <motion.div
      {...props}
      initial={{ right: -100 }}
      animate={{ right: 15 }}
      transition={{
        duration,
        type: 'spring',
        stiffness: 400,
        damping: 20,
      }}
    >
      {props.children}
    </motion.div>
  );
}

export function Pop(props) {
  const duration = props.duration || 0.2;
  return (
    <motion.div
      {...props}
      initial={{ scale: 0.8 }}
      animate={{ scale: 1 }}
      transition={{
        duration,
        type: 'spring',
        stiffness: 260,
        damping: 20,
      }}
    >
      {props.children}
    </motion.div>
  );
}

export function CardPop(props) {
  const duration = props.duration || 0.2;
  return (
    <motion.div
      {...props}
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{
        duration,
        // type: 'spring',
        stiffness: 260,
        damping: 20,
      }}
    >
      {props.children}
    </motion.div>
  );
}

export function FadeIn(props) {
  const duration = props.duration || 0.2;
  return (
    <motion.div
      {...props}
      initial={{ opacity: 0, width: '100%' }}
      animate={{ opacity: 1, width: '100%' }}
      transition={{
        duration,
      }}
    >
      {props.children}
    </motion.div>
  );
}
